import * as React from 'react';
import './FooterLegalDocuments.less';
import TermsLink from '../../common/TermsLink';
import PrivacyLink from '../../common/PrivacyLink';
import FooterLink from '../../common/FooterLink';
import ReleaseNotesLink from '../../common/ReleaseNotesLink';

const FooterLegalDocuments = () => {
	return (
		<section className="footerLinks">
			<span className="globalFooterText">&middot;</span>
			<TermsLink />
			<span className="globalFooterText">&middot;</span>
			<PrivacyLink />
			<span className="globalFooterText">&middot;</span>
			<ReleaseNotesLink />
			<span className="globalFooterText">&middot;</span>
			<FooterLink text="Support" href="mailto:support@vetting.com" />
		</section>
	);
};

export default FooterLegalDocuments;
